(function () {
  'use strict';

  function text(key, values) { return window.PlaygeniI18n?.text(key, values) || ''; }

  var STATE_KEY = '__playgeniRaptorRuntime';
  if (window[STATE_KEY]) return;

  var state = {
    sections: new Map(),
    roots: new Set(),
    audio: null,
    audioSource: '',
    audioOwner: null,
    audioRequest: 0
  };
  var visibilityPausedVideos = new WeakSet();
  window[STATE_KEY] = state;

  function clamp(value) {
    return Math.max(0, Math.min(1, value));
  }

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function sectionFor(node) {
    return node && node.closest ? node.closest('[data-raptor-section], .shopify-section, [data-pg-product]') : null;
  }

  function statusFor(node) {
    var section = sectionFor(node);
    return section && section.querySelector('[data-audio-status], [data-pg-status]');
  }

  function setStatus(node, message) {
    var status = statusFor(node);
    if (status) status.textContent = message || '';
  }

  function audioSource(button) {
    return button.getAttribute('data-audio-src') || button.getAttribute('data-pg-audio');
  }

  function audioButtons(source) {
    return all('[data-audio-src], [data-pg-audio]').filter(function (button) {
      return audioSource(button) === source;
    });
  }

  function audioLabel(button) {
    return button.getAttribute('data-audio-label') || text('audio.sample_html');
  }

  function setAudioButton(button, playing, busy) {
    var label = audioLabel(button);
    var book = button.closest('[data-book-v3]');
    if (book) book.classList.toggle('is-story-playing', playing && !busy);
    if (playing) button.classList.add('is-audio-player');
    button.setAttribute('aria-pressed', playing ? 'true' : 'false');
    var visibleLabel = button.querySelector('.raptor-sample-label');
    var name = visibleLabel ? visibleLabel.textContent.trim() : '';
    button.setAttribute('aria-label', (name ? name + ' — ' : '') + text(playing ? 'audio.pause_html' : 'audio.play_html', {title:label}));
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function setAudioButtons(source, playing, busy) {
    audioButtons(source).forEach(function (button) {
      setAudioButton(button, playing, busy);
    });
  }

  function pauseVideos(except) {
    all('[data-raptor-video]').forEach(function (video) {
      if (video !== except) { visibilityPausedVideos.delete(video); video.pause(); }
    });
  }

  function pauseVideoOffscreen(video) {
    if (!video.paused) visibilityPausedVideos.add(video);
    video.pause();
  }

  function pauseAudio(messageNode) {
    state.audioRequest += 1;
    if (state.audio) state.audio.pause();
    stopAudioVisualizer();
    if (state.audioSource) setAudioButtons(state.audioSource, false, false);
    if (messageNode) setStatus(messageNode, text('audio.paused_html'));
    state.audioOwner = null;
  }

  function initAudioVisualizer(audio) {
    if (state.audioContext || state.audioGraphFailed) return;
    var AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    try {
      var context = new AudioContext();
      var analyser = context.createAnalyser();
      analyser.fftSize = 128;
      analyser.smoothingTimeConstant = .72;
      var source = context.createMediaElementSource(audio);
      // Keep playback connected even if visualisation is unavailable.
      source.connect(context.destination);
      source.connect(analyser);
      state.audioContext = context;
      state.audioAnalyser = analyser;
      state.audioBins = new Uint8Array(analyser.frequencyBinCount);
    } catch (error) { state.audioGraphFailed = true; }
  }

  function stopAudioVisualizer() {
    if (state.audioFrame) window.cancelAnimationFrame(state.audioFrame);
    state.audioFrame = 0;
    all('[data-audio-eq] i').forEach(function (bar) { bar.style.transform = 'scaleY(.15)'; });
  }

  function startAudioVisualizer() {
    stopAudioVisualizer();
    var buttons = audioButtons(state.audioSource);
    buttons.forEach(function (button) { button.dataset.audioVisualizer = state.audioAnalyser ? 'live' : 'fallback'; });
    if (!state.audioAnalyser || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var bars = buttons.map(function (button) { return all('[data-audio-eq] i', button); });
    function draw() {
      if (!state.audio || state.audio.paused || document.hidden) { stopAudioVisualizer(); return; }
      state.audioAnalyser.getByteFrequencyData(state.audioBins);
      bars.forEach(function (group) {
        group.forEach(function (bar, i) {
          var value = state.audioBins[2 + i * 3] / 255;
          bar.style.transform = 'scaleY(' + Math.max(.15, value).toFixed(3) + ')';
        });
      });
      state.audioFrame = window.requestAnimationFrame(draw);
    }
    draw();
  }

  function updateAudioTime() {
    if (!state.audio) return;
    var elapsed = Math.floor(state.audio.currentTime || 0);
    var text = Math.floor(elapsed / 60) + ':' + String(elapsed % 60).padStart(2, '0');
    audioButtons(state.audioSource).forEach(function (button) {
      var time = button.querySelector('[data-audio-time]');
      if (time) time.textContent = text;
    });
  }

  function ensureAudio() {
    if (state.audio) return state.audio;
    state.audio = new window.Audio();
    state.audio.crossOrigin = 'anonymous';
    state.audio.preload = 'none';
    state.audio.addEventListener('timeupdate', updateAudioTime);
    state.audio.addEventListener('pause', stopAudioVisualizer);
    state.audio.addEventListener('playing', startAudioVisualizer);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAudioVisualizer();
      else if (state.audio && !state.audio.paused) startAudioVisualizer();
    });
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', function () {
      if (state.audio && !state.audio.paused) startAudioVisualizer();
    });
    state.audio.addEventListener('ended', function () {
      stopAudioVisualizer();
      if (state.audioSource) setAudioButtons(state.audioSource, false, false);
      state.audioOwner = null;
    });
    state.audio.addEventListener('error', function () {
      stopAudioVisualizer();
      var owner = state.audioOwner;
      if (state.audioSource) setAudioButtons(state.audioSource, false, false);
      if (owner) setStatus(owner, text('audio.error_html'));
      state.audioOwner = null;
    });
    return state.audio;
  }

  function toggleAudio(button) {
    var source = audioSource(button);
    var audio = ensureAudio();
    initAudioVisualizer(audio);
    if (state.audioContext && state.audioContext.state === 'suspended') state.audioContext.resume().catch(function () {});

    if (state.audioSource === source && !audio.paused) {
      pauseAudio(button);
      return;
    }

    var request = ++state.audioRequest;
    if (state.audioSource && state.audioSource !== source) {
      audio.pause();
      stopAudioVisualizer();
      setAudioButtons(state.audioSource, false, false);
    }
    pauseVideos();
    if (state.audioSource !== source) { audio.src = source; audio.currentTime = 0; }
    state.audioSource = source;
    state.audioOwner = sectionFor(button);
    setAudioButtons(source, true, true);
    updateAudioTime();
    setStatus(button, text('audio.loading_html', {title:audioLabel(button)}));

    var playback;
    try {
      playback = audio.play();
    } catch (error) {
      playback = Promise.reject(error);
    }
    playback.then(function () {
      if (request !== state.audioRequest || state.audioSource !== source) return;
      setAudioButtons(source, true, false);
      updateAudioTime();
      startAudioVisualizer();
      setStatus(button, text('audio.playing_html', {title:audioLabel(button)}));
    }).catch(function (error) {
      if (request !== state.audioRequest) return;
      audio.pause();
      setAudioButtons(source, false, false);
      setStatus(button, text('audio.error_html'));
      state.audioOwner = null;
    });
  }

  // Scroll may pause a user-started sample, but must never start or resume it.
  document.addEventListener('raptor:book-ready', function (event) {
    var book = event.target;
    if (!book.matches('[data-book-v3]')) return;
    if (!event.detail.ready && state.audioOwner === book) pauseAudio();
  });

  function initBook(section, signal, cleanups) {
    var books = all('[data-raptor-book]', section);
    if (section.matches('[data-raptor-book]')) books.unshift(section);
    books.forEach(function (bookRoot) {
      if (bookRoot.hasAttribute('data-book-v3')) return;
      var track = bookRoot.querySelector('[data-book-track]');
      var object = bookRoot.querySelector('[data-book-object]');
      var content = bookRoot.querySelector('[data-book-content]');
      var openButton = bookRoot.querySelector('[data-book-open]');
      var closeButton = bookRoot.querySelector('[data-book-close]');
      var status = bookRoot.querySelector('[data-book-status]');
      if (!track || !object || !content || !openButton || !closeButton) return;

      var desktop = window.matchMedia('(min-width: 900px)');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var override = null;
      var overrideAt = 0;
      var frame = 0;
      var animationTimer = 0;

      function clearBookAnimation() {
        if (animationTimer) window.clearTimeout(animationTimer);
        animationTimer = 0;
        bookRoot.classList.remove('is-book-animating');
      }

      function setOpen(open, announce) {
        var progress = open ? 1 : 0;
        object.style.setProperty('--book-progress', String(progress));
        bookRoot.style.setProperty('--book-progress', String(progress));
        openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) content.removeAttribute('inert');
        else {
          if (content.contains(document.activeElement)) openButton.focus();
          content.setAttribute('inert', '');
        }
        if (announce && status) status.textContent = open ? text('audio.book_opened_html') : text('audio.book_closed_html');
      }

      function updateFromScroll() {
        frame = 0;
        if (!desktop.matches || reduced.matches) return;
        if (override !== null) {
          if (Math.abs(window.scrollY - overrideAt) <= 80) {
            setOpen(override === 1, false);
            return;
          }
          override = null;
          clearBookAnimation();
        }
        var distance = Math.min(window.innerHeight * 0.6, 600);
        var progress = clamp((80 - track.getBoundingClientRect().top) / Math.max(distance, 1));
        object.style.setProperty('--book-progress', String(progress));
        bookRoot.style.setProperty('--book-progress', String(progress));
        var open = progress >= 1;
        openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) content.removeAttribute('inert');
        else {
          if (content.contains(document.activeElement)) openButton.focus();
          content.setAttribute('inert', '');
        }
      }

      function queueScroll() {
        if (!frame) frame = window.requestAnimationFrame(updateFromScroll);
      }

      function explicitly(open) {
        override = open ? 1 : 0;
        overrideAt = window.scrollY;
        clearBookAnimation();
        bookRoot.classList.add('is-book-animating');
        animationTimer = window.setTimeout(clearBookAnimation, 700);
        setOpen(open, true);
      }

      function resetMotionMode() {
        override = null;
        clearBookAnimation();
        setOpen(false, false);
        queueScroll();
      }

      bookRoot.classList.add('is-enhanced');
      if (status) status.setAttribute('aria-live', 'polite');
      setOpen(false, false);
      openButton.addEventListener('click', function () { explicitly(true); }, { signal: signal });
      closeButton.addEventListener('click', function () { explicitly(false); }, { signal: signal });
      bookRoot.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') explicitly(false);
      }, { signal: signal });
      object.addEventListener('transitionend', clearBookAnimation, { signal: signal });
      window.addEventListener('scroll', queueScroll, { passive: true, signal: signal });
      desktop.addEventListener('change', resetMotionMode);
      reduced.addEventListener('change', resetMotionMode);
      queueScroll();

      cleanups.push(function () {
        if (frame) window.cancelAnimationFrame(frame);
        clearBookAnimation();
        desktop.removeEventListener('change', resetMotionMode);
        reduced.removeEventListener('change', resetMotionMode);
        bookRoot.classList.remove('is-enhanced');
        bookRoot.style.removeProperty('--book-progress');
        object.style.removeProperty('--book-progress');
        openButton.removeAttribute('aria-expanded');
        content.removeAttribute('aria-hidden');
        content.removeAttribute('inert');
        if (status) {
          status.removeAttribute('aria-live');
          status.textContent = '';
        }
      });
    });
  }

  function initCarousels(section, signal) {
    var carousels = all('[data-raptor-carousel]', section);
    if (section.matches('[data-raptor-carousel]')) carousels.unshift(section);
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var previous = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;
      function move(direction) {
        track.scrollBy({
          left: direction * Math.max(track.clientWidth * 0.85, 1),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      if (previous) previous.addEventListener('click', function () { move(-1); }, { signal: signal });
      if (next) next.addEventListener('click', function () { move(1); }, { signal: signal });
    });
  }

  function initAudio(section) {
    all('[data-audio-src], [data-pg-audio]', section).forEach(function (button) {
      if (!button.querySelector('[data-audio-player]')) {
        var original = document.createElement('span');
        original.className = 'raptor-sample-label';
        while (button.firstChild) original.appendChild(button.firstChild);
        button.appendChild(original);
        var player = document.createElement('span');
        player.setAttribute('data-audio-player', '');
        player.setAttribute('aria-hidden', 'true');
        player.innerHTML = '<span class="raptor-audio-toggle"></span><span data-audio-eq>' + '<i></i>'.repeat(16) + '</span><span data-audio-time>0:00</span>';
        button.appendChild(player);
      }
      var source = audioSource(button);
      var playing = Boolean(state.audio && state.audioSource === source && !state.audio.paused);
      setAudioButton(button, playing, false);
    });
  }

  function syncVideoControls(section, video) {
    var toggle = section.querySelector('[data-video-toggle]');
    var mute = section.querySelector('[data-video-mute]');
    if (toggle) {
      toggle.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
      toggle.setAttribute('aria-label', text(video.paused ? 'video.play_html' : 'video.pause_html'));
    }
    if (mute) {
      mute.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      mute.setAttribute('aria-label', text(video.muted ? 'video.unmute_html' : 'video.mute_html'));
    }
  }

  function initVideos(section, signal, cleanups) {
    all('[data-raptor-video]', section).forEach(function (video) {
      var toggle = section.querySelector('[data-video-toggle]');
      var mute = section.querySelector('[data-video-mute]');
      var originalControls = video.controls;
      var poster = video.parentElement.querySelector('[data-video-poster]');
      if (poster) video.addEventListener('playing', function () { poster.hidden = true; }, { signal: signal });
      video.autoplay = false;
      video.pause();
      if (video.dataset.posterDesktop && window.matchMedia('(min-width:750px)').matches) {
        video.poster = video.dataset.posterDesktop;
      }
      if (toggle) {
        video.controls = false;
        section.classList.add('is-video-enhanced');
      }
      syncVideoControls(section, video);
      if (toggle) toggle.addEventListener('click', function () {
        visibilityPausedVideos.delete(video);
        if (video.paused) {
          pauseAudio();
          pauseVideos(video);
          Promise.resolve(video.play()).catch(function () { syncVideoControls(section, video); });
        } else video.pause();
        syncVideoControls(section, video);
      }, { signal: signal });
      if (mute) mute.addEventListener('click', function () {
        video.muted = !video.muted;
        syncVideoControls(section, video);
      }, { signal: signal });
      video.addEventListener('play', function () {
        visibilityPausedVideos.delete(video);
        pauseAudio();
        pauseVideos(video);
        syncVideoControls(section, video);
      }, { signal: signal });
      video.addEventListener('pause', function () { syncVideoControls(section, video); }, { signal: signal });
      video.addEventListener('volumechange', function () { syncVideoControls(section, video); }, { signal: signal });
      if (video.hasAttribute('data-video-autoplay')) {
        video.muted = true;
        var attempted = false;
        function autoStart(visible) {
          if (!visible) { pauseVideoOffscreen(video); return; }
          if (video.hasAttribute('data-video-desktop-autoplay') && !window.matchMedia('(min-width:750px)').matches) return;
          if ((attempted && !visibilityPausedVideos.has(video)) || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (state.audio && !state.audio.paused) return;
          attempted = true;
          Promise.resolve(video.play()).catch(function () { syncVideoControls(section, video); });
        }
        if ('IntersectionObserver' in window) {
          var videoObserver = new window.IntersectionObserver(function (entries) {
            entries.forEach(function (entry) { autoStart(entry.isIntersecting); });
          }, { threshold: .25 });
          videoObserver.observe(video);
          cleanups.push(function () { videoObserver.disconnect(); });
        } else autoStart(true);
      }
      cleanups.push(function () {
        video.pause();
        video.controls = originalControls;
        section.classList.remove('is-video-enhanced');
        if (poster) poster.hidden = false;
      });
    });
  }

  function initMenu(section, signal, cleanups) {
    var toggle = section.querySelector('[data-raptor-menu-toggle]');
    var menu = section.querySelector('[data-raptor-menu]');
    if (!toggle || !menu) return;
    var desktop = window.matchMedia('(min-width: 750px)');

    function setOpen(open, returnFocus) {
      var mobileOpen = open && !desktop.matches;
      toggle.setAttribute('aria-expanded', mobileOpen ? 'true' : 'false');
      menu.setAttribute('aria-hidden', desktop.matches || mobileOpen ? 'false' : 'true');
      section.classList.toggle('is-menu-open', mobileOpen);
      if (!mobileOpen && returnFocus) toggle.focus();
    }
    function handleBreakpointChange() {
      setOpen(false, false);
    }
    setOpen(false, false);
    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true', false);
    }, { signal: signal });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false, false);
    }, { signal: signal });
    section.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false, true);
    }, { signal: signal });
    desktop.addEventListener('change', handleBreakpointChange);
    cleanups.push(function () {
      desktop.removeEventListener('change', handleBreakpointChange);
      section.classList.remove('is-menu-open');
      toggle.removeAttribute('aria-expanded');
      menu.removeAttribute('aria-hidden');
    });
  }

  // Keep the native form until the embed is usable; never discard an in-progress signup.
  function initNewsletter(section, cleanups) {
    var mount = section.querySelector('.klaviyo-form-ViEsxx');
    if (!mount || !window.MutationObserver) return;
    var fallback = section.querySelector('[data-newsletter-fallback]');
    var panel = section.querySelector('.raptor-newsletter-panel');
    var handedOver = false;
    function updateLabels() {
      var input = mount.querySelector('input[type="email"]');
      if (fallback && !handedOver) {
        var nativeInput = fallback.querySelector('input[type="email"]');
        var keepNative = fallback.contains(document.activeElement) || (nativeInput && nativeInput.value) || fallback.querySelector('[data-newsletter-result]');
        if (input && mount.querySelector('button') && !keepNative) {
          fallback.hidden = true;
          mount.hidden = false;
          handedOver = true;
        }
      }
      if (input && input.getAttribute('placeholder') === 'Email Address') input.setAttribute('placeholder', text('newsletter.email_placeholder_html'));
      all('button', mount).forEach(function (button) {
        if (button.textContent.trim() === 'Get My Code') button.textContent = text('newsletter.sign_up_html');
      });
      if (panel) {
        var nativeSuccess = fallback && !fallback.hidden && fallback.querySelector('[data-newsletter-result][role="status"]');
        var embedSuccess = handedOver && !input && mount.querySelector('form') && mount.textContent.trim();
        panel.classList.toggle('is-newsletter-success', Boolean(nativeSuccess || embedSuccess));
      }
    }
    var observer = new window.MutationObserver(updateLabels);
    observer.observe(mount, { childList: true, subtree: true, characterData: true });
    updateLabels();
    cleanups.push(function () { observer.disconnect(); if (panel) panel.classList.remove('is-newsletter-success'); });
  }

  function initFeedback(section, signal, cleanups) {
    var carousel = section.querySelector('[data-feedback-carousel]');
    if (!carousel || carousel.hasAttribute('data-feedback-v3')) return;
    var feedbacks = all('[data-feedback]', carousel);
    if (!feedbacks.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var count = Math.min(3, feedbacks.length), slots = feedbacks.slice(0, count);
    var cursor = count, slotIndex = 0, timer = null, swapTimer = null, inView = false, selected = false;
    carousel.classList.add('is-feedback-enhanced');
    carousel.style.setProperty('--feedback-rows', count);
    function place(feedback, slot) {
      feedback.style.gridArea = (slot + 1) + ' / 1';
      feedback.setAttribute('data-feedback-slot', slot + 1);
    }
    function show(feedback, visible) {
      feedback.classList.toggle('is-feedback-active', visible);
      feedback.setAttribute('aria-hidden', String(!visible));
      feedback.inert = !visible;
    }
    feedbacks.forEach(function (feedback, i) {
      place(feedback, i % count);
      show(feedback, i < count);
    });
    function cancel() {
      window.clearTimeout(timer); window.clearTimeout(swapTimer);
      timer = null; swapTimer = null;
      slots.forEach(function (feedback) { show(feedback, true); });
    }
    function schedule() {
      cancel();
      if (count < 3 || !inView || document.hidden || reduced.matches || selected) return;
      timer = window.setTimeout(function () {
        var slot = slotIndex++ % count, outgoing = slots[slot];
        show(outgoing, false);
        swapTimer = window.setTimeout(function () {
          var incoming = outgoing;
          if (feedbacks.length > count) {
            do { incoming = feedbacks[cursor++ % feedbacks.length]; } while (slots.indexOf(incoming) !== -1);
          }
          place(incoming, slot);
          slots[slot] = incoming;
          show(incoming, true);
          schedule();
        }, 850);
      }, 4200);
    }
    var controls = carousel.querySelector('[data-feedback-controls]');
    if (controls) {
      controls.hidden = feedbacks.length < 2;
      function navigate(direction) {
        cancel();
        var start = (feedbacks.indexOf(slots[0]) + direction + feedbacks.length) % feedbacks.length;
        slots = Array.from({ length: count }, function (_, i) { return feedbacks[(start + i) % feedbacks.length]; });
        cursor = (start + count) % feedbacks.length;
        feedbacks.forEach(function (feedback) { show(feedback, slots.indexOf(feedback) !== -1); });
        slots.forEach(function (feedback, i) {
          place(feedback, i);
          if (!reduced.matches && feedback.animate) feedback.animate([
            { opacity: .6, transform: 'translateY(10px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 550, delay: i * 70, easing: 'ease-out' });
        });
        schedule();
      }
      controls.querySelector('[data-feedback-prev]').addEventListener('click', function () { navigate(-1); }, { signal: signal });
      controls.querySelector('[data-feedback-next]').addEventListener('click', function () { navigate(1); }, { signal: signal });
    }
    function sync() {
      if (reduced.matches) {
        cancel();
        feedbacks.forEach(function (feedback, i) { place(feedback, i); show(feedback, true); });
        carousel.style.setProperty('--feedback-rows', feedbacks.length);
      } else {
        feedbacks.forEach(function (feedback) { show(feedback, slots.indexOf(feedback) !== -1); });
        slots.forEach(function (feedback, i) { place(feedback, i); });
        carousel.style.setProperty('--feedback-rows', count);
        schedule();
      }
    }
    document.addEventListener('visibilitychange', sync, { signal: signal });
    reduced.addEventListener('change', sync, { signal: signal });
    section.addEventListener('shopify:block:select', function (event) {
      var feedback = feedbacks.find(function (item) { return item === event.target || item.contains(event.target); });
      if (!feedback) return;
      selected = true; cancel();
      if (slots.indexOf(feedback) === -1) { show(slots[0], false); slots[0] = feedback; place(feedback, 0); show(feedback, true); }
    }, { signal: signal });
    section.addEventListener('shopify:block:deselect', function () { selected = false; sync(); }, { signal: signal });
    var observer;
    if ('IntersectionObserver' in window) {
      observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.target === carousel) { inView = entry.isIntersecting; sync(); } });
      });
      observer.observe(carousel);
    } else inView = true;
    sync();
    cleanups.push(function () {
      cancel(); if (observer) observer.disconnect();
      if (controls) controls.hidden = true;
      carousel.classList.remove('is-feedback-enhanced'); carousel.style.removeProperty('--feedback-rows');
      feedbacks.forEach(function (feedback) { feedback.classList.remove('is-feedback-active'); feedback.removeAttribute('aria-hidden'); feedback.style.removeProperty('grid-area'); feedback.removeAttribute('data-feedback-slot'); feedback.inert = false; });
    });
  }

  // Scroll changes signed travel speed along the orbit, never the position directly.
  function initScrollShapes(section, signal, cleanups) {
    var shapes = all('[data-scroll-shape]', section);
    if (!shapes.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var visible = new Set();
    var frame = 0, lastFrame = 0, phase = 0, impulse = 0;
    var lastY = window.scrollY, lastScroll = performance.now();
    function active() { return visible.size && !document.hidden && !reduced.matches; }
    function stop() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0; lastFrame = 0; impulse = 0;
    }
    function tick(now) {
      frame = 0;
      if (!active()) return;
      var dt = lastFrame ? Math.min(50, Math.max(1, now - lastFrame)) : 16.67;
      lastFrame = now;
      phase += (.22 + impulse) * dt / 1000;
      impulse *= Math.exp(-dt / 1100);
      shapes.forEach(function (shape, index) {
        if (!visible.has(shape)) return;
        var offset = phase + index * 1.8;
        var direction = index % 2 ? -1 : 1;
        var x = Math.sin(offset) * 24 * direction;
        var y = Math.cos(offset) * 18;
        var rotate = Math.sin(offset) * 3 * direction;
        shape.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) rotate(' + rotate.toFixed(2) + 'deg)';
      });
      frame = window.requestAnimationFrame(tick);
    }
    function sync() {
      lastY = window.scrollY; lastScroll = performance.now();
      if (active()) { if (!frame) frame = window.requestAnimationFrame(tick); }
      else stop();
      if (reduced.matches) shapes.forEach(function (shape) { shape.style.removeProperty('transform'); });
    }
    var observer = 'IntersectionObserver' in window ? new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var shape = entry.target.querySelector('[data-scroll-shape]');
        if (entry.isIntersecting) visible.add(shape); else visible.delete(shape);
      });
      sync();
    }) : null;
    shapes.forEach(function (shape) {
      if (observer) observer.observe(shape.parentElement); else visible.add(shape);
    });
    if (!section.classList.contains('r2-story--features')) window.addEventListener('scroll', function () {
      var now = performance.now();
      var delta = window.scrollY - lastY;
      var velocity = delta / Math.max(16, now - lastScroll);
      lastY = window.scrollY; lastScroll = now;
      if (!active()) return;
      if (!delta) return;
      var direction = Math.sign(delta);
      // Reverse promptly when the scroll direction changes, then accumulate momentum.
      if (Math.sign(impulse) !== direction) impulse = 0;
      var kick = Math.min(2, Math.abs(delta) * .006 + Math.abs(velocity) * .35);
      impulse = direction * Math.min(4, Math.max(.4, Math.abs(impulse) + kick));
    }, { passive: true, signal: signal });
    document.addEventListener('visibilitychange', sync, { signal: signal });
    reduced.addEventListener('change', sync, { signal: signal });
    sync();
    cleanups.push(function () {
      stop();
      if (observer) observer.disconnect();
      shapes.forEach(function (shape) { shape.style.removeProperty('transform'); });
    });
  }

  function initSection(section) {
    if (!section || state.sections.has(section)) return;
    var controller = new window.AbortController();
    var cleanups = [];
    var observer = null;
    var record = { controller: controller, cleanups: cleanups, observer: null, inView: false };
    state.sections.set(section, record);
    state.roots.add(section);

    function setVisible(visible) {
      record.inView = visible;
      section.classList.toggle('is-in-view', visible && !document.hidden);
      if ((!visible || document.hidden)) {
        all('[data-raptor-video]', section).forEach(pauseVideoOffscreen);
      }
    }
    if ('IntersectionObserver' in window) {
      observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === section) setVisible(entry.isIntersecting);
        });
      });
      observer.observe(section);
      record.observer = observer;
    } else setVisible(true);

    initBook(section, controller.signal, cleanups);
    initCarousels(section, controller.signal);
    initVideos(section, controller.signal, cleanups);
    initMenu(section, controller.signal, cleanups);
    initNewsletter(section, cleanups);
    initFeedback(section, controller.signal, cleanups);
    initScrollShapes(section, controller.signal, cleanups);
  }

  function unloadSection(section) {
    var record = state.sections.get(section);
    if (!record) return;
    if (state.audioOwner === section) pauseAudio();
    record.controller.abort();
    if (record.observer) record.observer.disconnect();
    record.cleanups.forEach(function (cleanup) { cleanup(); });
    section.classList.remove('is-in-view');
    state.roots.delete(section);
    state.sections.delete(section);
  }

  function initialize(scope) {
    initAudio(scope || document);
    if (scope && scope.matches && scope.matches('[data-raptor-section]')) initSection(scope);
    all('[data-raptor-section]', scope || document).forEach(initSection);
  }

  function onReady() {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (state.audioOwner && event.target.contains(state.audioOwner)) pauseAudio();
    if (event.target.matches && event.target.matches('[data-raptor-section]')) unloadSection(event.target);
    all('[data-raptor-section]', event.target).forEach(unloadSection);
  });
  document.addEventListener('visibilitychange', function () {
    state.roots.forEach(function (section) {
      var record = state.sections.get(section);
      if (document.hidden) {
        section.classList.remove('is-in-view');
        all('[data-raptor-video]', section).forEach(function (video) { video.pause(); });
      } else section.classList.toggle('is-in-view', Boolean(record && record.inView));
    });
    if (document.hidden) pauseAudio();
  });
  document.addEventListener('click', function (event) {
    var audioButton = event.target.closest && event.target.closest('[data-audio-src], [data-pg-audio]');
    if (audioButton && !audioButton.disabled) toggleAudio(audioButton);
    var link = event.target.closest && event.target.closest('[data-raptor-cart]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== 'modal') return;
    var store;
    var registered = false;
    try {
      store = window.Alpine && typeof window.Alpine.store === 'function' && window.Alpine.store('modals');
      if (store && typeof store.isRegistered === 'function') registered = store.isRegistered('cart');
      else registered = Boolean(store && store.modals && store.modals.cart);
    } catch (error) {
      store = null;
    }
    if (!store || !registered || typeof store.open !== 'function') return;
    event.preventDefault();
    if (typeof store.closeAll === 'function') store.closeAll();
    store.open('cart');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });
  else onReady();
}());
